import React from 'react';
import {Article} from '../../types';
import NewsHoverItem from './NewsHoverItem';
import './hero.css';

interface NewsHoverContainerProps {
    articles: Article[];
    loading: boolean;
}

/** The three most important news posts: expanding tiles on desktop, a swipeable row on tablets and phones. */
const NewsHoverContainer = ({articles, loading}: NewsHoverContainerProps) => {
    if (loading) {
        return (
            <section className="hero" aria-hidden="true">
                {[0, 1, 2].map(i => <div key={i} className="hero-item skeleton"/>)}
            </section>
        );
    }
    if (!articles.length) return null;

    return (
        <section className="hero" aria-label="Wichtige News">
            {articles.slice(0, 3).map((article, index) => (
                <NewsHoverItem key={article.id} article={article} priority={index === 0}/>
            ))}
        </section>
    );
};

export default NewsHoverContainer;
